var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLocation30Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#0033AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4808 14.3572C16.9707 14.3572 18.1784 13.2059 18.1784 11.7858C18.1784 10.3656 16.9707 9.21436 15.4808 9.21436C13.991 9.21436 12.7832 10.3656 12.7832 11.7858C12.7832 13.2059 13.991 14.3572 15.4808 14.3572Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8757 14.3571C18.8525 18.8571 15.4805 24 15.4805 24C15.4805 24 12.1084 18.8571 10.0852 14.3571C8.06201 9.85714 11.434 6 15.4805 6C19.5269 6 22.8989 9.85714 20.8757 14.3571Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation30Px);
export default __webpack_public_path__ + "static/media/ic_location_30px.a29330311b5b70a3b2c1c465015c1bc6.svg";
export { ForwardRef as ReactComponent };